<template>
  <div
    :class="{ 'd-flex justify-content-between align-items-center': icon }"
    v-if="showStatistic || slots.text"
  >
    <fa-icon
      class="icon margin__r--18"
      :icon="icon"
      v-if="icon"
    />

    <p>
      <strong
        class="value d-flex justify-content-between color--sec"
        v-if="showStatistic"
      >
        <slot name="value">
          <app-money
            :amount="value"
            v-if="statistic.includes('amount_collected')"
          />

          <sporting-activities-distance
            :statistics="statistics?.sporting_statistics"
            v-else-if="statistic.includes('distance')"
          />

          <sporting-activities-time
            :statistics="statistics?.sporting_statistics"
            v-else-if="statistic.includes('time')"
          />

          <template v-else>
            {{ value }}
          </template>
        </slot>

        <slot name="tooltip" />
      </strong>

      <span
        class="text d-block"
        v-if="slots.text"
      >
        <slot
          name="text"
          :value="formatedValue"
        />
      </span>
    </p>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, useSlots } from 'vue'
import { get as _get } from 'lodash'

const AppMoney = defineAsyncComponent(() => import('&/atoms/AppMoney'))
const SportingActivitiesDistance = defineAsyncComponent(() => import('&/molecules/SportingActivitiesDistance'))
const SportingActivitiesTime = defineAsyncComponent(() => import('&/molecules/SportingActivitiesTime'))

const { statistics, statistic } = defineProps({
  icon: Array,
  statistics: { type: Object, default: () => ({}) },
  statistic: { type: String, required: true },
  showStatistic: { type: Boolean, default: true }
})

const slots = useSlots()

const value = computed(() => _get(statistics, statistic, 0))

const formatedValue = computed(() => {
  if (statistic.includes('distance')) return statistics?.sporting_statistics.to_km
  if (statistic.includes('time')) return statistics?.sporting_statistics.is_less_than_one_hour ? statistics?.sporting_statistics.to_minutes: statistics?.sporting_statistics.to_hours

  return value.value
})
</script>

<style lang="scss" scoped>
.icon {
  font-size: rem(18px);
}

.value {
  gap: 6px;
  font-weight: bold;
  font-size: em(24px);
  line-height: 1;

  @include mq(md) {
    font-size: em(32px);
  }
}

.text {
  margin-top: 3px;
}
</style>